import { Component, OnInit } from '@angular/core';
import { NavParams, ModalController } from '@ionic/angular';
import { AppSettings } from '../../shared/app-settings';
import { Storage } from '@ionic/storage-angular';
import { UserService } from '../../shared/user-service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'order-confirm-sales',
    templateUrl: 'order-confirm-sales.html',
    styleUrls: ['order-confirm-sales.scss'],
    standalone: false
})
export class OrderConfirmSalesComponent implements OnInit {
   order: any;
   VolumeToStandardTruck: boolean = AppSettings.VolumeToStandardTruck;
   depos: any[] = [];
   defaultDepotNo: string = '';
   isCompletionMode: boolean = false; // true = ferdigmelding, false = ny ordre
   validationError: string = '';

   // Leveringsdato-bekreftelse (kun ferdigmelding)
   plannedDeliveryDate: any;             // datoen som vises på ordren (fra forelder)
   dateMismatch: boolean = false;        // planlagt dato != i dag
   selectedDateOption: string = null;    // 'planned' | 'today' — ingen default (tvinger aktivt valg)
   plannedDateLabel: string = '';
   todayDateLabel: string = '';

    constructor(
        public navParams: NavParams,
        public modalCtrl: ModalController,
        private storage: Storage,
        private userService: UserService,
        private translateService: TranslateService
    ) {
        this.order = this.navParams.data.order;
        this.isCompletionMode = this.navParams.data.isCompletionMode || false;
        this.plannedDeliveryDate = this.navParams.data.plannedDeliveryDate;

        // Sammenlign planlagt leveringsdato mot dagens dato (dato-del, ikke klokkeslett)
        const today = new Date();
        this.todayDateLabel = this.formatDate(today);
        const planned = this.plannedDeliveryDate ? new Date(this.plannedDeliveryDate) : null;
        if (planned && !isNaN(planned.getTime())) {
            this.plannedDateLabel = this.formatDate(planned);
            this.dateMismatch = this.isCompletionMode && !this.isSameDay(planned, today);
        }
    }

    private isSameDay(a: Date, b: Date): boolean {
        return (
            a.getFullYear() === b.getFullYear() &&
            a.getMonth() === b.getMonth() &&
            a.getDate() === b.getDate()
        );
    }

    private formatDate(d: Date): string {
        const pad = (n: number) => (n < 10 ? '0' + n : '' + n);
        return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()}`;
    }

    onDeliveryDateOptionChange(option: string) {
        this.selectedDateOption = option;
        this.validationError = '';
    }

    async ngOnInit() {
        // Load default depot from localStorage
        const savedDepot = await this.storage.get(AppSettings.StorageKeys.Depot);
        if (savedDepot) {
            this.defaultDepotNo = savedDepot;
        }

        // Load depot list from API
        this.userService.getDepos().subscribe((data) => {
            this.depos = data;
            
            // Set default depot for all order lines if not already set
            if (this.order && this.order.Orderlines) {
                this.order.Orderlines.forEach(line => {
                    if (!line.DepotNo && this.defaultDepotNo) {
                        line.DepotNo = this.defaultDepotNo;
                    }
                });
            }
        });
    }

    onDepotChange(orderLine: any, depotNo: string) {
        orderLine.DepotNo = depotNo;
        this.validationError = ''; // Clear error when user makes a change
    }

    validateAndDismiss(save: boolean) {
        if (!save) {
            this.modalCtrl.dismiss(false);
            return;
        }

        // Only validate depot for completion mode (ferdigmelding)
        if (this.isCompletionMode) {
            const missingDepot = this.order.Orderlines.some(line => !line.DepotNo);
            if (missingDepot) {
                this.translateService.get('OrderConfirm.depotRequired').subscribe(message => {
                    this.validationError = message;
                });
                return;
            }

            // Tving et aktivt valg av leveringsdato når planlagt dato != i dag
            if (this.dateMismatch && !this.selectedDateOption) {
                this.translateService.get('OrderConfirm.deliveryDateRequired').subscribe(message => {
                    this.validationError = message;
                });
                return;
            }

            // Sett bekreftet leveringsdato på ordren
            if (this.dateMismatch) {
                const chosen =
                    this.selectedDateOption === 'today'
                        ? new Date().toISOString()
                        : this.plannedDeliveryDate;
                this.order.ConfirmedDeliveryDate = chosen;
                this.order.DeliveryDate = chosen;
            } else {
                // Ingen avvik (eller mangler dato): bruk vist dato, ellers dagens
                const chosen = this.plannedDeliveryDate || new Date().toISOString();
                this.order.ConfirmedDeliveryDate = chosen;
                this.order.DeliveryDate = chosen;
            }
        }

        // Send updated order with depot information back
        this.modalCtrl.dismiss(this.order);
    }

    dismiss(flag) {
        // Deprecated - use validateAndDismiss instead
        this.validateAndDismiss(flag);
    }
}
